import { Button, Group, Text } from "@mantine/core";
import { ChatConfigEditButton } from "./ChatConfigEditButton";
import { useGetApiAdminChatConfigGet, usePutApiAdminChatConfigReset, usePutApiAdminChatConfigUpdate } from "@/API";
import { useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import { modals } from "@mantine/modals";

export function ConfigPage() {
    const queryClient = useQueryClient()
    const config = useGetApiAdminChatConfigGet()
    const updateConfig_Mutation = usePutApiAdminChatConfigUpdate()
    const resetConfig_Mutation = usePutApiAdminChatConfigReset()
    return <>
        <Group>
            <ChatConfigEditButton config={config.data?.data} onChange={async v => {
                try {
                    await updateConfig_Mutation.mutateAsync({
                        data: v
                    })
                    queryClient.invalidateQueries({
                        queryKey: config.queryKey
                    })
                    notifications.show({ message: "更新成功" })
                } catch (e) {
                    notifications.show({ message: "更新失敗", color: "red" })
                }
            }}>
                <Button>
                    開啟聊天設定
                </Button>
            </ChatConfigEditButton>
            <Button onClick={async () => {
                modals.openConfirmModal({
                    title: '重設聊天設定',
                    children: (
                        <Text size="sm">
                            是否要重設聊天設定?
                        </Text>
                    ),
                    labels: { confirm: '重設', cancel: '取消' },
                    onConfirm: async () => {
                        try {
                            await resetConfig_Mutation.mutateAsync()
                            queryClient.invalidateQueries({
                                queryKey: config.queryKey
                            })
                            notifications.show({ message: "重設成功" })
                        } catch (e) {
                            notifications.show({ message: "重設失敗", color: "red" })
                        }
                    }
                });
            }}>重設聊天設定</Button>
        </Group>
    </>
}